namespace GeniuzPOS.InitialData {
    export class PsDiscCouponTypeColumns {
        static columnsKey = 'InitialData.PsDiscCouponType';
    }
}
